import { Link } from "react-router-dom";
import { money } from "../lib/api";
import { useCart } from "../context/CartContext";
import { TiltMedia } from "./TiltMedia";
import { ShoppingCart } from "lucide-react";

// Card mirrors the American Peptides catalog card: tilt media, uppercase name,
// category sub label, "from $X" price, and a full width cart icon Add to Cart button.
export const ProductCard = ({ product, index = 0 }) => {
  const { addItem } = useCart();
  const tiers = product.tiers?.length ? product.tiers : [{ qty: 1, price: product.price }];
  const base = tiers[0].price;
  const showFrom = (product.variants?.length > 1) || (tiers.length > 1);

  const quickAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const v = product.variants?.length ? product.variants[0] : null;
    const price = v ? (v.tiers?.[0]?.price ?? v.price) : base;
    addItem(product, { tierQty: 1, packPrice: price, variantLabel: v?.label, variantImage: v?.image });
  };

  return (
    <div
      className="group border border-white/12 bg-[#0B1024] sq-lg overflow-hidden flex flex-col fade-up hover:border-electric/40 hover:shadow-[0_8px_30px_rgba(110,96,255,0.14)] transition-all duration-300"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/products/${product.slug}`} className="block relative">
        {product.badge && (
          <span className="absolute top-3 left-3 z-10 bg-electric text-black text-[9px] tracking-[0.18em] uppercase font-bold px-2.5 py-1 sq-xs">
            {product.badge}
          </span>
        )}
        <TiltMedia className="aspect-square bg-[#121A3A]">
          <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
        </TiltMedia>
        <div className="p-4">
          <h3 className="font-display font-bold text-sm sm:text-base uppercase tracking-tight leading-tight text-white group-hover:text-electric transition-colors duration-200" data-testid={`product-name-${product.slug}`}>
            {product.name}
          </h3>
          <div className="text-[10px] tracking-[0.12em] uppercase text-white/40 mt-1.5">{product.category}</div>
          <div className="mt-3 font-display font-bold text-lg text-white" data-testid={`product-price-${product.slug}`}>
            {showFrom && <span className="text-white/45 text-xs font-medium lowercase">from </span>}{money(base)}
          </div>
        </div>
      </Link>

      <div className="mt-auto px-4 pb-4">
        {product.in_stock === false ? (
          <button disabled className="w-full py-3 text-[10px] tracking-[0.2em] uppercase font-bold border border-white/12 text-white/40 sq-sm cursor-not-allowed" data-testid={`out-of-stock-${product.slug}`}>
            Out of Stock
          </button>
        ) : showFrom ? (
          <Link
            to={`/products/${product.slug}`}
            className="w-full py-3 text-[10px] tracking-[0.2em] uppercase font-bold inline-flex items-center justify-center gap-2 border border-white/20 text-white sq-sm hover:bg-electric hover:text-black hover:border-electric transition-colors duration-200"
            data-testid={`select-options-${product.slug}`}
          >
            <ShoppingCart size={14} /> Add to Cart
          </Link>
        ) : (
          <button
            onClick={quickAdd}
            className="w-full py-3 text-[10px] tracking-[0.2em] uppercase font-bold inline-flex items-center justify-center gap-2 border border-white/20 text-white sq-sm hover:bg-electric hover:text-black hover:border-electric transition-colors duration-200"
            data-testid={`add-to-cart-${product.slug}`}
          >
            <ShoppingCart size={14} /> Add to Cart
          </button>
        )}
      </div>
    </div>
  );
};
